module.exports = __webpack_public_path__ + "static/media/yodastories.6b2e5110.gif";